import {Inject, Injectable, makeStateKey, Optional, PLATFORM_ID, StateKey, TransferState} from '@angular/core';
import {AppConfig} from '../types/AppConfig';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {TransferStateKeyEnum} from '../enums/TransferStateKeyEnum';

@Injectable()
export class AppConfigService {
  public appConfig: AppConfig;

  // private skipHosts: string[] = ['http://localhost:4000', 'http://localhost:4200'];

  constructor(
    @Optional() @Inject('GET_APPCONFIG') private getAppConfig: () => AppConfig,
    @Optional() @Inject('HOST') private host: string,
    @Optional() @Inject('IS_UNCACHED') private isUncached: string,
    @Inject(PLATFORM_ID) private platformId: any,
    private transferState: TransferState,
  ) {
    const CONFIG_STATE_KEY: StateKey<AppConfig> = makeStateKey(TransferStateKeyEnum.APP_CONFIG);

    if (isPlatformBrowser(this.platformId)) {
      this.appConfig = this.transferState.get<any>(CONFIG_STATE_KEY, {});
    }
    if (isPlatformServer(this.platformId)) {
      // this.conditionalUpdateHostInAppConfig(host);

      this.appConfig = this.getAppConfig();
      if (isUncached === 'true') {
        this.setUncachedUrls();
      }
      transferState.set(CONFIG_STATE_KEY, this.appConfig);
    }
  }

  // private conditionalUpdateHostInAppConfig(host: string): AppConfig {
  //   const appConfigObject = this.getAppConfig();
  //   if (this.skipHosts.indexOf(host) === -1) {
  //     appConfigObject.baseUrl = host + appConfigObject.baseUrl;
  //     appConfigObject.wpBackend = host + appConfigObject.wpBackend;
  //     appConfigObject.apiUrl = host + appConfigObject.apiUrl;
  //     appConfigObject.wordpressApiUrl = host + appConfigObject.wordpressApiUrl;
  //     appConfigObject.wordpressMenusApiUrl = host + appConfigObject.wordpressMenusApiUrl;
  //     appConfigObject.amazonS3Url = host + appConfigObject.amazonS3Url;
  //   }
  //   return appConfigObject;
  // }

  private setUncachedUrls(): void {
    const appConfigObject = this.getAppConfig();
    this.appConfig.baseUrl = appConfigObject.baseUrlNoCache;
    this.appConfig.wpBackend = appConfigObject.wpBackendNoCache;
    this.appConfig.apiUrl = appConfigObject.apiUrlNoCache;
    this.appConfig.wordpressApiUrl = appConfigObject.wordpressApiUrlNoCache;
    this.appConfig.wordpressMenusApiUrl = appConfigObject.wordpressMenusApiUrlNoCache;
  }
}
